export default __webpack_public_path__ + "static/media/MAIN Reedit PT_low.c9eb9773.mp4";